<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">
  <!-- <div id="snackbar">{{toastMsg}}</div> -->
  <!-- Section header start -->
  <div class="headerBackground card p-1 mb-2 tool-header-height">
    <div class="row padding2px">
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
        <span>
          <!-- <fa-icon class="fas checklistIcon"  [icon]="faCircle">
          </fa-icon> -->

          <fa-icon class="fas fa-lg autoCursor" title="click for smart checklist" (click)="openSmartChecklist()"
            [icon]="faPenNib"></fa-icon>
        </span>
      </div>
      <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4">
        <h6 class="headerFontSize cursorArrow">{{ 'menu.designer' | translate }}</h6>
      </div>
      <div class="col col-6 col-md-6 col-lg-6 col-sm-6 col-xs-6 cursorArrow">
        <p class="titleParagraph">{{'testDesigner.toolHeaderLine1' | translate}}<br>
          {{'testDesigner.toolHeaderLine2' | translate}}
        </p>
      </div>
      <div class="col col-2 col-md-2 col-lg-2 col-sm-2 col-xs-2">
        <table class="dropGroupBtn">
          <tr>
            <td rowspan="2">
              <span>
                <a type="button" (click)="entityName && generateMindMap()">
                  <fa-icon class="fas fa-lg" [icon]="faSitemap" title="mindmap"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span>
                <a type="button" (click)="entityName && openChatGPTassist()">
                  <fa-icon class="fas fa-lg toolLogoYellow" [icon]="faLightbulb" title="intelligent assistant"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span>
                <a type="button" class="" data-toggle="modal" data-target="#ytVideoLinkTD">
                  <fa-icon class="fas fa-lg" [icon]="faInfoCircle" title="help"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span (click)="entityName && generateReport('true')">
                <fa-icon class="fas fa-lg cursorPointer" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
            <td rowspan="2">
              <span class="autoCursor ">
                <fa-icon class="fas fa-lg extraIcon" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
          </tr>
        </table>
        <!-- <table class="dropGroupBtn">
          <tr>
            <td class="iconGroupHeight">
              <span>
                <a type="button" class="" data-toggle="modal" data-target="#ytVideoLinkTD">
                  <fa-icon class="fas" [icon]="faInfo"></fa-icon>
                </a>
              </span>
            </td>
            <td>
           
            </td>
          </tr>
          <tr class="bg-color-black">
            <td class="height25px">
              <span (click)="entityName && generateReport('true')">
                <fa-icon class="fas" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
            <td>
              <span>
                <fa-icon class="fas" [icon]="faJira" [ngClass]="{ dis:jiraInterfaceDisabled}" (click)="loadBugList()">
                </fa-icon>
              </span>
            </td>
          </tr>
        </table> -->
      </div>
      <!-- <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1">
				<table class="dropGroupBtn">
					<tr>
						<td class="iconGroupHeight">
							<span>
								<a type="button" class="" data-toggle="modal" data-target="#ytVideoLinkTD">
									<fa-icon class="fas" [icon]="faInfo"></fa-icon>
								</a>
							</span>
						</td>
						<td rowspan="2" class="widgetInterfaceButton">
							<span data-toggle="modal" data-target="#widgetInterfaceSection">
								<fa-icon class="fas" [icon]="faFileExport" title="report"></fa-icon>
							</span>
						</td>
					</tr>
					<tr class="bg-color-black">
						<td class="height25px">
							<span>
								<i class="fas fa-file-export"></i>
							</span>
						</td>
					</tr>
				</table>
			</div> -->
    </div>
  </div>
  <!-- Section header end -->
  <div class="test-designer tool-body-height">
    <div class="card p-1 mb-2 bg-white h-100">
      <div class="row strict">
        <div class="col-sm-2 col-xs-3 btn-padding pl-0">
          <div class="row strict radio-button">
            <div class="dropdown">
              <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                type="button" data-toggle="dropdown">
                <div class="row strict">
                  <div class="col-xs-10">
                    <span *ngIf="selectedModule!=''">{{selectedModule.mName}}
                    </span>
                    <span *ngIf="selectedModule==''">{{'deepDive.chooseEUT' | translate }}</span>
                  </div>
                  <div class="col-xs-1 col-xs-offset-1 pull-right ">
                    <span class="caret"></span>
                  </div>
                </div>
              </button>
              <ul class="dropdown-menu deepDriveEntityDropdown">
                <li class="row strict" *ngFor="let module of modelData.modules">
                  <div class="col-xs-11 col-xs-offset-1  dropdown-item cursorPointer" (click)="selectModule(module)">
                    {{module.mName}}
                  </div>
                </li>
              </ul>
            </div>

          </div>
        </div>
        <div class="col-sm-10 col-xs-9 btn-padding pr-0">

          <div class="dropdown">
            <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
              type="button" data-toggle="dropdown">
              <div class="row strict">
                <div class="col-xs-10 span-on-button ">
                  {{entityName||'deepDive.chooseEntityButton' | translate }}
                </div>
                <div class="col-xs-1 col-xs-offset-1 pull-right ">
                  <span class="caret"></span>
                </div>
              </div>

            </button>

            <ul class="dropdown-menu fit-size">
              <li *ngIf="entitiesExists(eutTypes[index]) == false">
                <div class="alert alert-warning cursorArrow">
                  <strong>No
                    entities
                    <!-- {{modelData.getEntityType(modelData.eutTypes[modelData.index]) | lowercase}} -->
                    defined.
                  </strong>
                </div>
              </li>
              <div class="row" *ngIf="entitiesExists(eutTypes[index]) == true">
                <div class="col-xs-12">
                  <div class="input-group input-group-sm">
                    <input type="text" class="form-control search-add-on" [(ngModel)]="searchText"
                      [placeholder]="'entities.searchEntity' | translate" ngDefaultControl>
                    <span class="input-group-addon " id="basic-addon2">
                      <fa-icon class="fas icon-black" [icon]="faSearch"></fa-icon>
                    </span>
                  </div>
                </div>
              </div>
              <li
                *ngFor="let eut of modelData.listOfEUTs|moduleEntityListFilter:selectedModule:filterTypeList:searchText"
                (click)="loadEntityDetails(eut);scenariosStatus()">
                <a class="dropdown-item">({{getScenarioCountByeutID(eut)}}) {{eut.eType}} | {{eut.eName}}</a>
              </li>
            </ul>
          </div>




        </div>

        <!-- <div class="col-sm-2 col-xs-5 btn-padding paddingright0px paddingleft0px">
                  <div class="row strict" ng-if='selectedEUT == "TT"'>
                    <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
                      <div>
                        <button type="button"
                          ng-class="{ dis:showText==true || plusBtnEnabled==false}"
                          (click)="selectedCheckList(true,true,'')"
                          class="btn btn-default btn-block btn-sm padding3px">
                          <i class="fa fa-plus menuItemsClrBlack paddingtop3px paddingbottom3px"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
                      <div>
                        <button type="button"
                          ng-class="{ dis:showText==true || actionBtnsEnabled==false}"
                          (click)="editCheckListName(checklistName)"
                          class="btn btn-default btn-block btn-sm padding3px">
                          <i class="fa fa-edit menuItemsClrBlack paddingtop3px paddingbottom3px"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
                      <div *ngIf="!showText">
                        <button type="button" data-toggle="modal" data-target="#checklistDeleteConfirmModel1"
                          ng-class="{ dis:showText==true || actionBtnsEnabled==false}"
                          class="btn btn-default btn-block btn-sm padding3px">
                          <i class="fa fa-trash menuItemsClrBlack paddingtop3px paddingbottom3px"></i>
                        </button>
                      </div>
                      <div *ngIf="showText">
                        <button type="button" (click)="clear()"
                          class="btn btn-default btn-block btn-sm padding3px">
                          <i class="fa fa-times menuItemsClrBlack"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div> -->
      </div>
      <div class="row strict">
        <ul class="nav nav-tabs">
          <li>
            <a data-toggle="tab" id="designerActiveTab" (click)="createActivity('Tdsp');changeTab('specs')"
              ng-attr-data-target="#specsTab">{{'testDesigner.specsTab' | translate }}</a>
          </li>
          <li class="active" (click)="createActivity('Tdsc');changeTab('scenario')">
            <a data-toggle="tab" ng-attr-data-target="#scenariosTab">{{'testDesigner.scenariosTab' | translate }}
              <fa-icon class="far fa-lg marginLeft20 cursorPointer float-right" title="Non covered"
                *ngIf="entityScenarioNill == true" [icon]="faCircle"></fa-icon>
              <fa-icon class="far fa-lg marginLeft20 cursorPointer float-right" title="Some covered"
                *ngIf="entityScenarioOne == true" [icon]="faTimesCircle"></fa-icon>
              <fa-icon class="far fa-lg marginLeft20 cursorPointer float-right" title="All covered"
                *ngIf="entityScenarioAll == true" [icon]="faCheckCircle"></fa-icon>
            </a>
          </li>
          <li (click)="quillNoteReload();createActivity('Tdde');changeTab('design')">
            <a data-toggle="tab" ng-attr-data-target="#designCasesTab">{{'testDesigner.designNoteTab' | translate }}</a>
          </li>
        </ul>
      </div>
      <div class="tab-content test-designer-nav-tab-content-height card">
        <!-- <div class="test-designer-fieldset-section-height pb-3"> -->
        <div ng-attr-id="specsTab" *ngIf="currentTab == 'specs'" class="tab-pane fade active in h-100">
          <div class="row padding-vertical h-50">
            <div class="col-xs-6 space-separable h-100">
              <fieldset
                class="scheduler-border h-100 margin-top02em card cardExplore p-1 mb-2 bg-white designerPopover">
                <legend class="scheduler-border cursorArrow">{{'deepDive.ddBcHeader'| translate }}</legend>
                <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                  data-html="true" role="button" data-toggle="popover" data-placement="left"
                  [title]="'deepDive.ddBcHeaderTip'| translate ">
                </div>
                <div class="control-group fieldset-text-box-height paddingtop7px">
                  <div class="row strict h-100">
                    <div class="col-xs-12 h-100">
                      <textarea id="BC" rows="1" class=" form-control transparent square-edge bg-color-black h-100"
                        [(ngModel)]="selectedEntityDetails.bc" [readonly]="!entityName" (focusout)="updateEntityDetails()"
                        [placeholder]="'deepDive.ddBcHeaderPlaceholder'|translate" ngDefaultControl></textarea>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="col-xs-6 space-separable h-100">
              <fieldset
                class="scheduler-border h-100 margin-top02em card cardExplore p-1 mb-2 bg-white designerPopover">
                <legend class="scheduler-border cursorArrow">{{ 'deepDive.ddAcHeader' | translate }}</legend>
                <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                  data-html="true" role="button" data-toggle="popover" data-placement="left"
                  [title]="'deepDive.ddAcHeaderTip'| translate ">
                </div>
                <div class="control-group fieldset-text-box-height paddingtop7px">
                  <div class="row strict h-100">
                    <div class="col-xs-12 h-100">
                      <textarea id="AC" rows="1" class="form-control transparent square-edge bg-color-black h-100"
                        [(ngModel)]="selectedEntityDetails.ac" [readonly]="!entityName" (focusout)="updateEntityDetails()"
                        [placeholder]="'deepDive.ddAcHeaderPlaceholder'|translate" ngDefaultControl></textarea>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div class="row padding-vertical h-50">
            <div class="col-xs-6 space-separable h-100">
              <fieldset
                class="scheduler-border h-100 margin-top02em card cardExplore p-1 mb-2 bg-white designerPopover">
                <legend class="scheduler-border cursorArrow">{{ 'deepDive.ddOutcomeHeader' | translate }}</legend>
                <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                  data-html="true" role="button" data-toggle="popover" data-placement="left"
                  [title]="'deepDive.ddOutcomeHeaderTip'| translate">
                </div>
                <div class="control-group fieldset-text-box-height paddingtop7px">
                  <div class="row strict h-100">
                    <div class="col-xs-12 h-100">
                      <textarea id="outcomes" rows="1"
                        class=" form-control transparent square-edge bg-color-black h-100" [(ngModel)]="selectedEntityDetails.outcomes"
                        [readonly]="!entityName" (focusout)="updateEntityDetails()"
                        [placeholder]="'deepDive.ddOutcomeHeaderPlaceholder'|translate" ngDefaultControl></textarea>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="col-xs-6 space-separable h-100">
              <fieldset
                class="scheduler-border h-100 margin-top02em card cardExplore p-1 mb-2 bg-white designerPopover">
                <legend class="scheduler-border cursorArrow">{{'deepDive.ddPiHeader'| translate }}</legend>
                <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                  data-html="true" role="button" data-toggle="popover" data-placement="left"
                  [title]="'deepDive.ddPiHeaderTip'| translate">
                </div>
                <div class="control-group fieldset-text-box-height paddingtop7px">
                  <div class="row strict h-100">
                    <div class="col-xs-12 h-100">
                      <textarea id="pi" rows="1" class=" form-control transparent square-edge bg-color-black h-100"
                        [(ngModel)]="selectedEntityDetails.pIssues" [readonly]="!entityName" (focusout)="updateEntityDetails()"
                        [placeholder]="'deepDive.ddPiHeaderPlaceholder'|translate" ngDefaultControl></textarea>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div ng-attr-id="scenariosTab" *ngIf="currentTab == 'scenario'" class="tab-pane fade active in h-100">
          <div class="row strict h-100 card bg-white">
            <div class="col-xs-12 h-100">
              <div class="row strict scen-border border-none h-100 card bg-white">
                <div class="col-xs-12 h-100">



                  <!-- <button *ngIf="scenarioExist()"
                          class="btn btn-default btn-xs btn-block add-new-block-button mapperReadOnly"
                          (click)="add('', -1)"
                          ng-class="{dis:selectedTest=='' || selectedTestName == ''}">
                          <i class="fa fa-plus icon menuItemsClrBlack"></i>
                          <label>{{'testDesigner.scenarioEmpty' | translate }}</label>
                        </button> -->
                  <!-- ng-hide="scenarioExist()" -->
                  <table id="designerScenTable"
                    class="table table-bordered ui-sort-table table-xs h-100 mb-0 env1 bg-color-black designerScenatioTable">
                    <thead class="w-100">
                      <tr class="row strict border-bottom1px menuItemsClrWhite">
                        <th class="col-sm-1 col-xs-2 border-right1px">
                          <!-- <center>Test type</center> -->
                          <div class="dropdown">
                            <button
                              class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                              type="button" data-toggle="dropdown">
                              <div class="row strict">
                                <div class="col-xs-7 span-on-button">
                                  Level
                                </div>
                                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu text-color-black w-200 dropdownWidth">
                              <li class="row padding-vertical" *ngFor="let level of config.levels">
                                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                  <div style="text-align: center;">
                                    <input class="checkboxReadOnly cursorPointer"
                                      (click)="addToLevelFilter(level,$event.target.checked)" type="checkbox">
                                  </div>
                                </div>
                                <div
                                  class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                                  {{level}}
                                </div>
                              </li>
                            </ul>
                          </div>

                        </th>
                        <th class="col-sm-1 col-xs-2 border-right1px">
                          <!-- <center>Test type</center> -->
                          <div class="dropdown">
                            <button
                              class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                              type="button" data-toggle="dropdown">
                              <div class="row strict">
                                <div class="col-xs-7 span-on-button">
                                  Test
                                </div>
                                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu text-color-black w-200">
                              <li class="row padding-vertical" *ngFor="let a of testTypes">
                                <!-- |filter:{'eType':selectedEUT} -->
                                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                  <div style="text-align: center;">
                                    <input class="checkboxReadOnly cursorPointer"
                                      (click)="addToAttributeFilter(a.symbol,$event.target.checked);" type="checkbox">
                                  </div>
                                </div>
                                <div
                                  class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                                  {{a.name+" ("+a.symbol+")"}}
                                </div>
                              </li>

                              <li class="row padding-vertical" *ngFor="let a of config.listOfAttributesUpdated">
                                <!-- |filter:{'eType':selectedEUT} -->
                                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                  <div style="text-align: center;">
                                    <input class="checkboxReadOnly cursorPointer"
                                      (click)="addToAttributeFilter(a.symbol,$event.target.checked)"
                                      [checked]="isCheckedAtt(a.symbol)" type="checkbox">
                                  </div>
                                </div>
                                <div
                                  class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                                  {{a.name+" ("+a.symbol+")"}}
                                </div>
                              </li>
                            </ul>
                          </div>

                        </th>
                        <th class="col-sm-1 col-xs-2 border-right1px">
                          <!-- <center>{{ 'testDesigner.priorityColumnHeader' | translate }}</center> -->


                          <div class="dropdown">
                            <button
                              class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                              type="button" data-toggle="dropdown">
                              <div class="row strict">
                                <div class="col-xs-7 span-on-button">
                                  Type
                                </div>
                                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu text-color-black w-200 dropdownWidth">
                              <li class="row padding-vertical" *ngFor="let type of scenarioTypes">
                                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                  <div style="text-align: center;">
                                    <input class="checkboxReadOnly cursorPointer"
                                      (click)="addToCrFilter(type,$event.target.checked)" type="checkbox">
                                  </div>
                                </div>
                                <div
                                  class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item cursorArrow">
                                  {{type}}
                                </div>
                              </li>
                            </ul>
                          </div>
                        </th>
                        <!-- <th class="col-sm-1 col-xs-2 border-right1px">
                          <div class="dropdown">
                            <button
                              class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                              type="button" data-toggle="dropdown">
                              <div class="row strict">
                                <div class="col-xs-7 span-on-button ">
                                  {{'testDesigner.personaColumnHeader' | translate}}
                                </div>
                                <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu text-color-black w-200">
                              <li class="row padding-vertical" *ngFor="let p of modelData.persona">
                                <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                  <div style="text-align: center;">
                                    <input class="checkboxReadOnly"
                                      (click)="addToPersonaFilter(p.pType,$event.target.checked);" type="checkbox">
                                  </div>
                                </div>
                                <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 dropdown-item">
                                  {{p.pName}}
                                </div>
                              </li>
                            </ul>
                          </div>
                        </th> -->
                        <th class="col-xs-6 col-sm-10 cursorArrow">
                          {{ 'testDesigner.scenarioColumnHeader' | translate }}
                          <fa-icon class="fas addDeleteButtons" style="margin-right: 1px;" [icon]="faRedo" title="clear"
                            (click)="scenarioAddReset()"></fa-icon>&nbsp;
                          <fa-icon class="fas addDeleteButtons" style="margin-right: 7px;" [icon]="faTrash"
                            title="delete" (click)="deleteScenarioModal(editscenariodesc)"></fa-icon>&nbsp;
                          <!-- <fa-icon class="fas addDeleteButtons" style="margin-right: 10px;" [icon]="faPlusSquare"
                          title="add" *ngIf="!editScenario.scenID"
                          (click)="CreateScenario()"></fa-icon> -->
                          <fa-icon class="fas addDeleteButtons" style="margin-right: 10px;" [icon]="faSave" title="save"
                            (click)="CreateScenario()"></fa-icon>
                        </th>

                      </tr>
                      <tr class="row strict border-bottom1px background-black" auto-crud>
                        <!-- on-create="add('', $index)"
                                on-delete="delete($index)" -->
                        <!-- |filter: checklistName -->
                        <td class="col-sm-1 col-xs-2 no-padding">
                          <div class="dropdown">
                            <button class="btn btn-default btn-sm btn-block dropdown-toggle scenario-button-height"
                              type="button" data-toggle="dropdown">

                              <div class="row strict">
                                <div class="col-xs-12 span-on-button">
                                  <span *ngIf="newscenariolevel!=''">{{newscenariolevel}}
                                  </span>
                                  <span *ngIf="newscenariolevel==''">Level</span>
                                </div>
                                <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu menuItemsClrBlack dropdownWidth">

                              <li class="row strict" *ngFor="let level of config.levels" (click)="selectLevel(level)">
                                <div class="col-xs-12 col-xs-offset-1  dropdown-item cursorPointer">
                                  {{level}}
                                </div>
                              </li>

                            </ul>
                          </div>
                        </td>
                        <td class="col-sm-2 col-xs-3 no-padding">
                          <div class="dropdown">
                            <button class="btn btn-default btn-sm btn-block dropdown-toggle scenario-button-height"
                              type="button" (click)="updateTestTypeStatus()" data-toggle="dropdown">

                              <div class="row strict">
                                <div class="col-xs-10 span-on-button">
                                  <span *ngIf="newscenarioattr!=''">{{selectedTest.symbol}}
                                  </span>
                                  <span *ngIf="newscenarioattr==''">{{'testDesigner.chooseTest' | translate }}</span>
                                </div>
                                <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu menuItemsClrBlack">

                              <!-- <li class="row strict" *ngFor="let a of testTypes" (click)="selectTest(a)">
                                <div class="col-xs-11 col-xs-offset-1  dropdown-item">

                                  {{a.name+" ("+a.symbol+")"}}
                                </div>
                              </li> -->
                              <li class="row strict cursorPointer" *ngFor="let Attr of scenarioStatusTestTypes"
                                (click)="selectTest(Attr)">
                                <div class="col-xs-11 col-xs-offset-1  dropdown-item">
                                  <fa-icon class="fas" title="Not specified" *ngIf="!Attr.satisfy"
                                    [icon]="faCircle"></fa-icon>
                                  <fa-icon class="fas icon-black" title="Covered"
                                    *ngIf="(Attr.satisfy == true && Attr.stated == true)"
                                    [icon]="faCheckCircle"></fa-icon>
                                  <fa-icon class="fas icon-black" title="Not covered"
                                    *ngIf="(Attr.satisfy == true && Attr.stated == false)"
                                    [icon]="faTimesCircle"></fa-icon>&nbsp;&nbsp;{{Attr.name}}
                                </div>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <!-- <td></td> -->
                        <td class="col-sm-1 col-xs-2 no-padding">
                          <div class="dropdown">
                            <button class="btn btn-default btn-sm btn-block dropdown-toggle scenario-button-height"
                              type="button" data-toggle="dropdown">

                              <div class="row strict">
                                <div class="col-xs-12 span-on-button">
                                  <span *ngIf="newscenariocr!=''">{{newscenariocr}}
                                  </span>
                                  <span *ngIf="newscenariocr==''">Type</span>
                                </div>
                                <div class="col-xs-1 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu menuItemsClrBlack dropdownWidth">

                              <li class="row strict" *ngFor="let type of scenarioTypes" (click)="selectType(type)">
                                <div class="col-xs-12 col-xs-offset-1  dropdown-item cursorPointer">
                                  {{type}}
                                </div>
                              </li>

                            </ul>
                          </div>
                        </td>
                        <!-- <td class="col-sm-1 col-xs-2 no-padding">
                          <div class="dropdown">
                            <button
                              class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                              type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <div class="row strict">
                                <div class="col-xs-8 span-on-button ">
                                  {{newscenariopersona.length ||0}}
                                </div>
                                <div class="col-xs-2 col-xs-offset-1 pull-right ">
                                  <span class="caret"></span>
                                </div>
                              </div>
                            </button>
                            <ul class="dropdown-menu z-index">
                              <li class="row strict" *ngFor="let p of modelData.persona">
                                <div class="col-xs-3 col-sm-3 col-md-3 col-lg-2 col-xl2">
                                  <div style="text-align: center;"><input
                                      (click)="mapScenarioToPerson(p.pType,$event.target.checked)" type="checkbox">
                                  </div>
                                </div>
                                <div
                                  class="col-xs-9 col-sm-9 col-md-9 col-lg-10 col-xl-10 dropdown-item menuItemsClrBlack">
                                  {{p.pName}}
                                </div>
                              </li>
                            </ul>
                          </div>
                        </td> -->
                        <td class="col-xs-6 col-sm-10">
                          <!-- textarea shows when user updating or deleting scenario -->
                          <input *ngIf="editScenario.scenID"
                            class="form-control transparent scenario-input-field menuItemsClrBlack" rows="1"
                            [placeholder]="'testDesigner.scenarioModify'|translate" autosize="true"
                            id="designerScenTextarea" [(ngModel)]="editscenariodesc" name="scenarioModifyField"
                            (keyup.enter)="CreateScenario()" style="background-color : lightyellow !important;"
                            ngDefaultControl>

                          <!-- textarea shows when user adding scenario -->
                          <input *ngIf="!editScenario.scenID"
                            class="form-control transparent scenario-input-field menuItemsClrBlack" rows="1"
                            [placeholder]="'testDesigner.scenarioAdd'|translate" autosize="true"
                            id="designerScenTextarea" [(ngModel)]="editscenariodesc" name="scenarioAddField"
                            (keyup.enter)="CreateScenario()" style="background-color : lightyellow !important;"
                            ngDefaultControl>
                          <!-- <label auto-crud-source-readonly class="form-control transparent ellipsis"
                                  ng-bind="scenarios[$index].description"></label>
                                <textarea auto-crud-source class="form-control transparent" rows="1" autosize="true"
                                  [(ngModel)]="scenarios[$index].description"
                                  ng-blur="onFocusOut(scenarios[$index].description,$index)"></textarea>  -->
                        </td>
                      </tr>
                    </thead>
                    <tbody class="scenario-table test-designer-scenarios-table-body-height overflowAuto"
                      [(ngModel)]="modelData.scenarios" *ngIf="selectedEntityeID != ''" ngDefaultControl>
                      <tr
                        class="ui-sortable-item row strict border-bottom1px menuItemsClrWhite clickable-row cursorPointer"
                        *ngFor="let scenario of modelData.scenarios|entitytestscenariofilter:selectedEntityeID:levelSelected:attributeSelected:crSelected:filterTypeList;"
                        (click)="editScenarioData(scenario)">
                        <td class="col-sm-1 col-xs-2 no-padding">{{scenario.attribute.level}}</td>
                        <td class="col-sm-1 col-xs-2 no-padding">{{scenario.attribute.symbol}}</td>
                        <td class="col-sm-1 col-xs-2 no-padding">
                          {{scenario.cr}}
                        </td>
                        <!-- <td class="col-sm-1 col-xs-2 no-padding">
                          {{scenario.persona.length}}</td> -->
                        <td class="col-xs-6 col-sm-10">{{scenario.description}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ng-attr-id="designCasesTab" *ngIf="currentTab == 'design'" class="tab-pane fade active in h-100">
          <div id="designerQuillCSS" class="test-designer-quill-content-height">
            <quill-editor (onEditorChanged)="editorChanged($event)" (onBlur)="blur($event)"
              [(ngModel)]="selectedEntityNotes.notes">
              <div quill-editor-toolbar>
                <span class="ql-formats">
                  <select class="ql-header"></select>
                  <button class="ql-bold" [title]="'Bold'"></button>
                  <button class="ql-italic" [title]="'Italic'"></button>
                  <button class="ql-underline" [title]="'Underline'"></button>
                  <button class="ql-list" value="ordered"></button>
                  <button class="ql-list" value="bullet"></button>
                  <!-- <button class="ql-image" [title]="'Image'"></button>
                  <button class="ql-code" [title]="'Code'"></button> -->
                </span>
              </div>
            </quill-editor>
          </div>

          <div>

            <div class="row full-width pl-4 pr-4">
              <div class="col-xs-3 col-sm-6 col-md-7 col-lg-9 col-xl-9 pr-2" style="width: 70%;">
              </div>
              <div class="col-xs-7 col-sm-5 col-md-4 col-lg-2 col-xl-2 pl-2 pr-2" style="width: 21%;">
                <div class="form-group">
                  <div class="col-12 pl-0 pr-0">
                    <div class="dropup">
                      <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                        type="button" data-toggle="dropdown">
                        <div class="row strict">
                          <div class="col-xs-12 span-on-button">
                            <span *ngIf="selectedTestName!=''">{{selectedTestName}}
                            </span>
                            <span *ngIf="selectedTestName==''">Test Type</span>
                          </div>
                          <div class="col-xs-1 col-xs-offset-1 pull-right ">
                            <span class="caret"></span>
                          </div>
                        </div>
                      </button>
                      <ul class="dropdown-menu menuItemsClrBlack dropdownWidth">
                        <li class="row strict cursorPointer" *ngFor="let Attr of Config.listofFunctionalityTestTypes"
                          (click)="selectTest(Attr)">
                          <div class="col-xs-12 col-xs-offset-1  dropdown-item">
                            {{Attr.name}}
                          </div>
                        </li>
                        <li class="row strict cursorPointer" *ngFor="let Attr of Config.listOfAttributesUpdated"
                          (click)="selectTest(Attr)">
                          <div class="col-xs-12 col-xs-offset-1  dropdown-item">
                            {{Attr.name}}
                          </div>
                        </li>
                      </ul>
                    </div>

                  </div>
                </div>
              </div>
              <div class="col-xs-2 col-sm-1 col-xl-1 col-lg-1 col-md-1 pr-2 pl-0">
                <button type="button" (click)="checkQuillSelection()"
                  class="btn btn-default btn-block btn-sm float-right paddingtop3px paddingbottom3px">
                  <fa-icon class="fas icon-black" [icon]="faPlus"></fa-icon>
                </button>
              </div>
            </div>
          </div>
          <!-- </div> -->


          <!-- <iframe id='designerNotepad' class="h-100 w-100" src="./scenariosEditor.html"></iframe> -->
          <!-- <p>Scenarios tab note</p> -->
        </div>
        <!-- //othertwo tabs content -->
        <!-- </div> -->
      </div>
      <!-- </div> -->
      <!-- //tabs content -->
    </div>
  </div>
  <!-- Section footer start -->
  <div class="headerBackground card p-1 mt-2 tool-footer-height">
    <div class='row pb-0 pt-0'>
      <div id="testdesignerTip" class="carousel slide" data-ride="carousel" data-interval="false">
        <!-- Wrapper for slides -->
        <div class="carousel-inner text-color-yellow">
          <div class="row item active text-color-yellow">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #1 : {{'testDesigner.tip1' | translate}}
            </div>
          </div>

          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #2 : {{'testDesigner.tip2' | translate}}
            </div>
          </div>

          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #3 : {{'testDesigner.tip3' | translate}}
            </div>
          </div>
        </div>
        <!-- Left and right controls -->
        <a class="left carousel-control carousel-tip-align display-flex" data-target="#testdesignerTip"
          data-slide="prev">
          <span>
            <fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control carousel-tip-align display-flex" data-target="#testdesignerTip"
          data-slide="next">
          <span>
            <fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <!-- Section footer end -->
  <!-- Youtube video Modal -->
  <!-- <div class="modal fade bd-example-modal-lg" id="ytVideoLinkTD" tabindex="-1" role="dialog"
    aria-labelledby="ytVideoLinkTD" aria-hidden="true">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content ytVideoLink">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" (click)="terminateVideo()"
              aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">{{'youtubeVideoTitle.testdesigner' | translate}}</h4>
          </div>
          <div class="modal-body">
            <iframe width="100%" height="100%" class="youtubeVideo" id="TdVideoLink" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <div class="modal fade bd-example-modal-lg" id="ytVideoLinkTD" tabindex="-1" role="dialog"
    aria-labelledby="ytVideoLinkTD" aria-hidden="true">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content ytVideoLink">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" (click)="terminateVideo()"
              aria-hidden="true">&times;</button>
            <h4 class="modal-title cursorArrow" id="myModalLabel">{{'youtubeVideoTitle.testdesigner' | translate}}</h4>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <iframe width="100%" height="100%" class="youtubeVideo" id="TdVideoLink" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The error message popup modal -->
  <!-- The scenario duplicate error message modal -->
  <div class="modal fade" id="duplicateScenarioErrorPopupModelDesigner" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">{{duplicateScenario}}</label>
                </div>
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">{{errorMessage}}</label>
                </div>
                <div class="form-element text-align-center">
                  <button type="button" class="btn btn-secondary modalActionBtn orgUserListOkbtn pr-0 pl-0"
                    data-dismiss="modal">{{ 'ok' | translate }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- The plan delete confirm message modal -->

  <!-- The Scenario delete Confirm Message Modal -->
  <div class="modal fade" id="deleteScenarioConfirmPopupModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <!-- <div class="form-element text-align-center">
						<label class="form-label marginbottom6px contentEllipsis text-align-center"
						  title={{landscape.entityModel.duplicateEntity}}>{{landscape.entityModel.duplicateEntity}}</label>
					  </div> -->
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px text-align-center">{{message}}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <button type="button" class="btn btn-secondary modalActionBtn marginright10per" data-dismiss="modal"
              (click)="deleteScenarioByEdit();resetDesignerRowColorOnFilter()">{{ 'yes' | translate }}</button>
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal"
              (click)="resetDesignerRowColorOnFilter()">
              {{ 'no' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- The empty scenario add error popup modal -->
  <div class="modal fade" id="emptyScenAddErrorPopup" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">{{scenarioEmpty}}</label>
                  <!-- <label class="form-label marginbottom6px">{{testDesigner.controller.emptyScenErrMsg}}</label> -->
                </div>
              </div>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer text-align-center">
            <!-- <button type="button" class="btn btn-secondary modalActionBtn marginright10per"
					  ng-click="openMenu('switch');closeNav()">Yes</button> -->
            <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
              {{ 'ok' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>